export default "__VITE_ASSET__DEa2LVYX__"